import React, { useRef } from 'react';
import { motion, useSpring, useTransform, useMotionTemplate } from 'framer-motion';

// Tilt component for card animation
export function Tilt({
  children,
  className = '',
  rotationFactor = 15,
  isReverse = false,
}) {
  const ref = useRef(null);
  const x = useSpring(0);
  const y = useSpring(0);
  
  const rotateX = useTransform(
    y,
    [-0.5, 0.5],
    isReverse ? [rotationFactor, -rotationFactor] : [-rotationFactor, rotationFactor]
  );
  
  const rotateY = useTransform(
    x,
    [-0.5, 0.5],
    isReverse ? [-rotationFactor, rotationFactor] : [rotationFactor, -rotationFactor]
  );

  const transform = useMotionTemplate`perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const xPos = (e.clientX - rect.left) / rect.width - 0.5;
    const yPos = (e.clientY - rect.top) / rect.height - 0.5;
    x.set(xPos);
    y.set(yPos);
  };

  return (
    <motion.div
      ref={ref}
      className={className}
      style={{
        transformStyle: 'preserve-3d',
        transform,
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={() => {
        x.set(0);
        y.set(0);
      }}
    >
      {children}
    </motion.div>
  );
}

// Updated Gallery Card component with adjusted glow effect
export function GalleryCard({ image, title, subtitle }) {
  return (
    <Tilt rotationFactor={8} isReverse>
      <div className="group relative w-[270px]">
        {/* Adjusted glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl opacity-20 group-hover:opacity-30 transition duration-300 blur-lg"></div>
        
        {/* Card content */}
        <div className="relative flex w-full flex-col overflow-hidden rounded-xl border border-zinc-950/10 bg-zinc-900">
          <div className="relative">
            <img 
              src={image} 
              alt={title}
              className="h-48 w-full object-cover"
            />
          </div>
          <div className="p-4">
            <h3 className="font-mono text-sm font-medium text-zinc-400">
              {title}
            </h3>
            <p className="text-sm text-white">
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </Tilt>
  );
}